import React, { Component } from 'react'
// import * as _ from 'lodash'
import './style.css'

import State from '../State'
import CloseButtonIcon from '../CloseButtonIcon'

class AboutPopup extends Component {

  handleCloseClick = function() {
    State.action('closeAboutPopup')
  }

  render() {

    var classes = 'about-popup'
    if(State.ui.showAboutPopup)
      classes += ' active'

      // <div className="button-wrapper"><div className="button" onClick={this.handleCloseClick}>Close</div></div>
    return (
      <div className={classes}>
        <div className="close-button"><CloseButtonIcon clickHandler={this.handleCloseClick} /></div>

        <div>
          <div>This Moisture Balance Calculator is an interactive application for estimating the moisture balance of
a house, based on answers to questions about moisture generation, occupancy, heating, ventilation
and maintenance. If the home moisture is out of balance, easy actions can be explored to regain
moisture balance.</div>

          <div>However, while our focus is on moisture, there are other issues which can affect comfort, health and
wellbeing. The user should be aware that the Moisture Balance Calculator should be used alongside
other assessments in order to attain a more holistic balance. For example there is no point having a
moisture balanced house which is too hot or too cold, or where you cannot have parties!</div>

          <div>For a home (or building) to be in balance (not only moisture balance) a Whole Building Approach is
recommended which integrates fabric energy efficiency measures (such as insulation, new windows,
draught proofing), services improvement (particularly ventilation, heating and controls) along with
proper consideration of how people live and use the building. The context of the building (its
exposure, age, condition, form, appearance, etc) also needs to be considered. When all of these
aspects are integrated well, a building is in balance.</div>

          <div>Energy Efficiency measures, including insulation, draught proofing and ventilation applied as part of
a Whole House approach can help to retain heat within the home as well as maintain a fresh and
pleasant air atmosphere within the home, thus contributing to keep the house in balance.</div>

          <div>This moisture balance calculator tool has been developed by the UK Centre for Moisture in Buildings
(UKCMB) (<a href="http://www.ukcmb.org">www.ukcmb.org</a>). Funding and support from the Mineral Wool Insulation Manufacturers
Association (MIMA) (<a href="http://www.mima.info">www.mima.info</a>) is gratefully acknowledged. The work has been undertaken by
Isabel Carmona and Peter Cook working with Neil May and Dimitrios Rovas of the UKCMB.</div>

          <div>All drawing work by Isabel Carmona.</div>

          <div>The Moisture Balance Calculator is free to use. Copyright of the tool is retained by UKCMB.</div>

          <div>The copyright of any document referenced remains with its authors.</div>

          <div>Contact: for further information, please contact UKCMB: <a href="mailto:ukcmb@ucl.ac.uk">ukcmb@ucl.ac.uk</a></div>
        </div>
      </div>
    );
  }
}

export default AboutPopup;



// WEBPACK FOOTER //
// ./src/AboutPopup/index.js